import React from 'react';
import { IdeasSection } from '../initiatives/IdeasSection';
export function HomeInitiatives() {
  return <IdeasSection id="explore-ideas" title="Explore Our Ideas" body="Discover the concepts behind SyNeural’s research, including proposals for how demonstrated judgment could inform institutional trust and civic responsibility." link={{
    label: 'Visit Research',
    href: '/research'
  }} data-id="element-508" data-mp="3lkojt3q27j16" />;
}